import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { MembershipsListView } from '@/features/memberships/components/memberships-list-view'
import { membershipStatusSchema } from '@/features/memberships/data/schema'

const DEFAULT_STATUS_FILTER = ['active', 'scheduled'] as const

const membershipsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  planId: z.array(z.string()).optional().catch([]),
  discountId: z.array(z.string()).optional().catch([]),
  // Si `status` falta en la URL (carga directa o boton "Limpiar") se reaplican
  // los estados por defecto aqui. Antes lo hacia un efecto en la vista que
  // miraba la ubicacion global del router y redirigia a /memberships,
  // bloqueando cualquier navegacion fuera de la pagina.
  status: z
    .array(membershipStatusSchema)
    .catch([...DEFAULT_STATUS_FILTER])
    .default([...DEFAULT_STATUS_FILTER]),
  q: z.string().optional().catch(''),
})

export const Route = createFileRoute('/_authenticated/memberships/')({
  component: MembershipsListView,
  validateSearch: membershipsSearchSchema,
})
